<template>
  <textarea
    :id="inputId"
    ref="textarea"
    :value="value"
    :class="inputClasses"
    :name="name"
    :rows="rows"
    :maxlength="maxlength"
    :minlength="minlength"
    :placeholder="placeholder"
    :disabled="disabled"
    :readonly="readonly"
    :required="required"
    :aria-label="ariaLabel"
    data-testid="bs-form-textarea"
    @input="handleInput"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @keydown="$emit('keydown', $event)"
  ></textarea>
</template>

<script>
export default {
  name: 'BsFormTextarea',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    name: {
      type: String,
      default: null,
    },
    rows: {
      type: Number,
      default: 3,
    },
    maxlength: {
      type: Number,
      default: null,
    },
    minlength: {
      type: Number,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    plaintext: {
      type: Boolean,
      default: false,
    },
    state: {
      type: [Boolean, null],
      default: null,
    },
    formatter: {
      type: Function,
      default: null,
    },
    ariaLabel: {
      type: String,
      default: null,
    },
  },
  computed: {
    inputId() {
      return this.id || `bs-textarea-${this._uid}`;
    },
    inputClasses() {
      const classes = [];
      if (this.plaintext) {
        classes.push('form-control-plaintext');
      } else {
        classes.push('form-control');
      }
      if (this.state === true) {
        classes.push('is-valid');
      } else if (this.state === false) {
        classes.push('is-invalid');
      }
      return classes;
    },
  },
  methods: {
    handleInput(event) {
      let val = event.target.value;
      if (this.formatter) {
        val = this.formatter(val);
      }
      this.$emit('input', val);
    },
    focus() {
      if (this.$refs.textarea) {
        this.$refs.textarea.focus();
      }
    },
    select() {
      if (this.$refs.textarea) {
        this.$refs.textarea.select();
      }
    },
  },
};
</script>
